import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import translations from './lang/translations';

export default class InsertImageScorm extends Plugin {
    init() {
        translations();
        const editor = this.editor;
        const { t } = editor.locale;
        let selectedItems = [];

        editor.ui.componentFactory.add('InsertImageScorm', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: t('Insert image'),
                icon: imageIcon,
                tooltip: true
            });

            view.on('execute', () => {
                $.ajax({
                    url: '/admin/media/internal',
                    type: 'POST',
                    data: {
                        type: 'Groups',
                        id: 'internal'
                    },
                    success: function (response) {
                        let modalContent = document.createElement('div');
                        modalContent.classList.add('image-picker-container');

                        if (response.length === 0) {
                            modalContent.innerText = t('SCORM image folder is empty.');
                        }

                        for (let i = 0; i < response.length; i++) {
                            const container = document.createElement('div');
                            container.classList.add('image-picker-item');

                            const imagePath = response[i].url; // real path from internal media
                            container.dataset.href = imagePath;

                            const image = document.createElement('img');
                            image.classList.add('image-picker-image');
                            image.src = imagePath;

                            const name = document.createElement('p');
                            name.classList.add('image-picker-name');
                            name.innerText = response[i].name;
                            name.title = response[i].name;

                            container.append(image);
                            container.append(name);
                            modalContent.append(container);
                        }

                        $('.image_picker_modal-body').html(modalContent);

                        const containers = document.querySelectorAll('.image-picker-item');
                        if (containers) {
                            for (let i = 0; i < containers.length; i++) {
                                containers[i].addEventListener('click', function () {
                                    const imageUrl = this.dataset.href;
                                    const fileName = imageUrl.split('/').pop();
                                    const mediaToolId = window.mediaToolId || window.media_tool_id;

                                    if (!mediaToolId) {
                                        alert('Authoring tool media target is missing.');
                                        return;
                                    }

                                    $.ajax({
                                        url: '/admin/authoring/tool/upload-image',
                                        type: 'POST',
                                        headers: {
                                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                        },
                                        data: {
                                            image_url: imageUrl,
                                            file_name: fileName,
                                            media_tool_id: mediaToolId
                                        },
                                        success: function (res) {
                                            editor.execute('insertImage', {
                                                source: res.url
                                            });
                                            editor.editing.view.focus();
                                            $('#image_picker_modal').modal('hide');
                                        },
                                        error: function () {
                                            alert('Image upload failed.');
                                        }
                                    });
                                }, false);
                            }
                        }

                        $('#image_picker_modal').modal('show');
                    },
                    error: function () {
                        alert('Failed to fetch internal media.');
                    }
                });

                $('#image_picker_modal').on('hidden.bs.modal', function () {
                    sessionStorage.removeItem('save_images');
                    sessionStorage.removeItem('selected_item');
                    sessionStorage.removeItem('background_image');
                    selectedItems = [];
                    $('#image_picker_modal').off();
                });
            });

            return view;
        });
    }
}
